import gql from 'graphql-tag';

export const GET_PATHWAY_PAGE_INFO = gql`
  query($slug: String!) {
    getPathwayPageInfo(filter: { slug: [$slug] }) {
      pathway {
        id
        name
        description
        count_videos
        duration
        slug
        cpd_credits
        image_url
        logo_svg
        difficulty {
          title
          icon_url
          id
        }
        categories {
          id
          title
          slug
          parent {
            slug
            id
          }
        }
        videos {
          id
          title
          description
          duration
          preview_url
          video_url
          difficulty {
            id
            icon_url
            title
          }
          categories {
            id
            title
            slug
            parent {
              slug
              id
            }
          }
          user {
            id
            name
            slug
          }
        }
        available_quizes {
          count_of_questions
          description
          id
          location
          percentage_complete
          stars
          time_for_pass
          title
          percentage_complete
          stars
          questions {
            blooms_taxonomy_type
            title
            frontend_type
            id
            answers {
              id
              title
            }
          }
        }
        quizes {
          id
          title
          stars
        }
      }
      progress {
        video {
          id
          duration
          video_url
        }
        last_position
        chapter
        time
        completed
      }
    }
  }
`;

export const GET_PATHWAYS_YOU_MIGHT_ALSO_LIKE = gql`
  query($slug: String!) {
    listYouMightAlsoLikePathways(filter: { slug: [$slug] }) {
      id
      name
      image_url
      duration
      count_videos
      slug
    }
  }
`;

export const CHECK_QUIZ_ANSWERS = gql`
  mutation($input: PassedQuizInfo) {
    check_quiz_answers(input: $input) {
      hash
      date_passing
      percentage_complete
      count_of_questions
      count_correct_answers
      hash
    }
  }
`;

export const GET_PASSED_QUIZES_RESULTS_BY_HASH = gql`
  query($hash: String!) {
    GetPassedQuizesResultsByHash(hash: $hash) {
      passed
      pathway {
        id
        slug
        name
        description
      }
    }
  }
`;

export const GET_PASSED_QUIZES_BY_PATHWAY = gql`
  query($quiz_ids: [Int]!, $pathway_id: Int!) {
    GetPassedQuizesResults(quiz_ids: $quiz_ids, pathway_id: $pathway_id) {
      date_passing
      count_correct_answers
      count_of_questions
      percentage_complete
      passed
      hash
    }
  }
`;

export const GET_PATHWAYS_LIST = gql`
  query {
    listPathways {
      id
      name
      description
      count_videos
      cpd_credits
      duration
      slug
      image_url
      categories {
        id
        title
        slug
        parent {
          slug
          id
        }
      }
      difficulty {
        id
        icon_url
        title
      }
    }
  }
`;

export const GET_DISCOVER_PATHWAYS_DETAILED_INFO = gql`
  query($pathway_ids: [Int]!) {
    get_discover_pathways_detailed_info(pathway_ids: $pathway_ids) {
      id
      count_watched_videos
      passed_quizes {
        hash
        date_passing
      }
      not_passed_quizes {
        id
      }
    }
  }
`;
